import { makeStyles } from 'tss-react/mui';

const useStylesLogo: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  logo: {
    padding: '20px 0',
    marginTop: 2,
    '& img': {
      width: 170,
    },
    [theme.breakpoints.down('sm')]: {
      padding: '20px 5px',
    },
  },
}));

export default useStylesLogo;
